module.exports = "#btn-aceite{\r\n  background-color: #80c434;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/candidato/termo-aceite/termo-aceite.component.css
// module id = ./src/app/components/candidato/termo-aceite/termo-aceite.component.css
// module chunks = main